/* eslint-disable no-underscore-dangle */

import React from 'react'
import { FormatDate } from '../utils'

export type DateCellProps = {
  cellProps: any
}

export const dateFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { publishedDate } = data._original
  return (
    publishedDate &&
    FormatDate(publishedDate, 'dd-MMM-yyyy').toLowerCase().includes(filter)
  )
}

export const DateCell = (props: DateCellProps) => {
  const { cellProps } = props
  const { publishedDate } = cellProps.original
  return (
    <span>
      {publishedDate ? FormatDate(publishedDate, 'dd-MMM-yyyy') : null}
    </span>
  )
}
